import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {Router} from "@angular/router";
import {AuthModalService} from "./auth.modal.service";


@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private baseUrl = environment.API_BASE_URL + '/api/auth'; // change to your API URL
    token$ = new BehaviorSubject<string | null>(null);

    constructor(private http: HttpClient,
                private authModalService: AuthModalService,
                private router: Router) {
    }

    login(data: { identifier: string; password: string }): Observable<any> {
        //localStorage.clear();
        return this.http.post(`${this.baseUrl}/login`, data);
    }

    logout() {

        // Clear storage
        localStorage.clear();
        sessionStorage.clear();

        // First navigate to homepage
        this.router.navigate(['/']).then(() => {

            // Then open login popup
            this.authModalService.openLogin();
        });
    }

    setToken(token: string) {
        sessionStorage.setItem('accessToken', token);
        this.token$.next(token);
    }

    getToken(): string | null {
        return sessionStorage.getItem('accessToken');
    }

    isLoggedIn(): boolean {
        return !!sessionStorage.getItem('accessToken');
    }

    register(data: { name: string; email: string; mobile: string; password: string }): Observable<any> {
        return this.http.post(`${this.baseUrl}/register`, data);
    }

    setUserId(userId) {
        localStorage.setItem('userId', userId);
    }

    setEmail(email) {
        localStorage.setItem('email', email);
    }

    getUserId() {
        return localStorage.getItem('userId');
    }

    setRole(role) {
        localStorage.setItem('role', role);
    }

    getRole() {
        return localStorage.getItem('role');
    }

    getName() {
        return localStorage.getItem('name');
    }

    setName(name: string) {
        localStorage.setItem('name', name);
    }

    isAdmin() {
       return localStorage.getItem('role') === 'ADMIN';
    }
}
